// V4 only addds new entities - nothing to migrate.
export const migrateToV4 = (state)=>state;

//# sourceMappingURL=v04.js.map